module.exports = __webpack_public_path__ + "img/norway.56f62ee1.svg";